import { edgeFunctionData } from '../../services/edgeFunctionData';
import { updateJiraAuthor } from '../../services/jiraAuthors';
import { listWorklogAuthors } from '../../services/jiraSync';
import { notify } from '../../store/feedback';
import { jiraProjectKeys } from '../../utils/jira';

/* Auteurs de worklogs Jira : liste, et inclusion/exclusion du temps de chacun. */
export default function jiraAuthorsHandlers(deps) {
  const { setJiraAuthorsModal, appState } = deps;

  async function handleOpenJiraAuthors() {
    const projectKeys = jiraProjectKeys(appState.clients);
    if (!projectKeys.length) {
      setJiraAuthorsModal({ authors: [], noKeys: true });
      return;
    }
    setJiraAuthorsModal({ loading: true });
    try {
      const data = await edgeFunctionData(await listWorklogAuthors(projectKeys));
      setJiraAuthorsModal({ authors: data.authors || [], changed: false });
    } catch (e) {
      setJiraAuthorsModal(null);
      notify('Erreur lors du chargement des auteurs Jira : ' + (e.message || e));
    }
  }

  async function handleToggleJiraAuthor(accountId, included) {
    setJiraAuthorsModal(
      (m) =>
        m && {
          ...m,
          changed: true,
          authors: m.authors.map((a) => (a.accountId === accountId ? { ...a, included } : a)),
        },
    );
    await updateJiraAuthor(accountId, included);
  }

  return { handleOpenJiraAuthors, handleToggleJiraAuthor };
}
